import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import '@morningai/shared-ui/tokens.css'
import App from './App.jsx'
import { registerSW } from 'virtual:pwa-register'

if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister())
  })
  if ('caches' in window) {
    caches.keys().then(keys => {
      keys.forEach(key => caches.delete(key))
    })
  }
}

const updateSW = import.meta.env.PROD ? registerSW({
  onNeedRefresh() {
    if (confirm('New content available. Reload?')) {
      updateSW(true)
    }
  },
  onOfflineReady() {
    console.log('App ready to work offline')
  },
}) : () => {}

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
